var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_7950",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_7950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 39.0151V49.0237H10.985L40.503 19.5055L30.4946 9.49706L0.976562 39.0151ZM48.2428 11.7656C48.4902 11.5187 48.6866 11.2254 48.8205 10.9026C48.9545 10.5797 49.0234 10.2336 49.0234 9.88402C49.0234 9.53446 48.9545 9.18834 48.8205 8.86547C48.6866 8.5426 48.4902 8.24932 48.2428 8.00243L41.9976 1.75721C41.7507 1.50976 41.4574 1.31343 41.1345 1.17947C40.8117 1.04551 40.4655 0.976562 40.116 0.976562C39.7664 0.976563 39.4203 1.04551 39.0974 1.17947C38.7745 1.31343 38.4813 1.50976 38.2344 1.75721L33.3503 6.64091L43.3587 16.6497L48.2428 11.7656Z",
    fill: "#FF7F33"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrange);
export default __webpack_public_path__ + "static/media/edit_orange.5af8222fb92b0161a0a54711e9a63721.svg";
export { ForwardRef as ReactComponent };